import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { NSGridModule } from '@norfolk-southern/accessns-components';

import { DialogHeaderModule } from '@ruby/shared/dialogs/dialog-header/dialog-header.module';
import { MonitorDateDialog } from '@ruby/shared/dialogs/inventory-management/monitor-date/monitor-date.dialog';

@NgModule({
  declarations: [MonitorDateDialog],
  imports: [
    CommonModule,
    DialogHeaderModule,
    MatButtonModule,
    MatDialogModule,
    MatIconModule,
    NSGridModule,
    ReactiveFormsModule
  ],
  exports: [MonitorDateDialog]
})
export class MonitorDateDialogModule {}
